import { Upload, Drawer, Form, Radio, Input, Space, Button, message } from 'antd';
import SiteModuleDrawerOperationLogExtra from '../SiteModuleDrawerOperationLogExtra';
import { drawerWidth, fullWidthPageFormItemLayout } from '@utils/property';
import { useState, useEffect, Fragment } from 'react';
import './index.less';
import { uploadFileApi } from '@services/SiteModule';
import config from '@config';

export default ({ drawerState, setDrawerState, currentModule, updateModuleSettings }) => {
    const [form] = Form.useForm();

    const [docList, setDocList] = useState(null);

    const closeDrawer = () => setDrawerState({ ...drawerState, visible: false });

    // 文件上传
    const uploadFile = async info => {
        let formatType = null;
        const isJpgOrPng = info.file.type === 'application/pdf';

        const isLt30M = info.file.size / 1024 / 1024 < 31;
        if (!isJpgOrPng) {
            message.error('只能上传pdf 格式!');
            return;
        }
        if (!isLt30M) {
            message.error('文件大小不能超过30M');
            return;
        }
        if (info.file.type === 'application/pdf') {
            formatType = 'pdf';
        }

        const formData = new FormData();
        formData.append('file', info.file);
        formData.append('type', 14);
        const res = await uploadFileApi(formData);
        if (res) {
            const docItem = {
                name: info.file.name,
                path: res.data,
                ext: formatType,
            };
            setDocList(docItem);

            form.setFieldValue('doc', docItem);
            form.setFields([{ name: 'doc', errors: null }]);
        }
    };

    // 获取上传文件 - 前缀
    const getFileUrl = url => {
        if (url && url.includes('https')) {
            return url;
        }
        if (url && !url.includes('https')) {
            return config.OSS_PREFIX + url;
        }
        return null;
    };

    // 新增模块
    const onFinish = async values => {
        const params = {
            ...values,
            id: currentModule.id,
            data: JSON.stringify({ doc: docList }),
        };
        delete params.doc;
        updateModuleSettings(params);
    };

    useEffect(() => {
        if (currentModule && drawerState?.visible) {
            if (currentModule.data) {
                const data = JSON.parse(currentModule.data);
                setDocList(data.doc);
            }
            form.setFieldsValue({
                displayTitle: currentModule.displayTitle,
                displayTitleEn: currentModule.displayTitleEn,
                hiddenWeb: currentModule.hiddenWeb,
                hiddenH5: currentModule.hiddenH5,
                status: currentModule.status,
                path: currentModule.path,
            });
        }
    }, [currentModule]);

    return (
        <Drawer
            closable={{ placement: 'end' }}
            title={`模块配置：${currentModule?.displayTitle}`}
            className="applog-record-drawer"
            size="100%"
            placement="bottom"
            push={false}
            open={drawerState?.moduleType === 3 && drawerState.visible}
            onClose={closeDrawer}
            footer={
                <div className="custom-drawer-footer" style={{ textAlign: 'right' }}>
                    <Space>
                        <Button onClick={closeDrawer}>取消</Button>
                        <Button type="primary" form="JournalModuleForm" htmlType="submit">
                            确定
                        </Button>
                    </Space>
                </div>
            }
        >
            <SiteModuleDrawerOperationLogExtra siteModuleId={currentModule?.id} />
            <Form name="JournalModuleForm" form={form} {...fullWidthPageFormItemLayout} onFinish={onFinish}>
                <Form.Item name="displayTitle" label="显示标题" rules={[{ required: true, message: '显示标题不能为空' }]}>
                    <Input placeholder="请输入模块显示标题" />
                </Form.Item>

                <Form.Item name="displayTitleEn" label="英文显示标题">
                    <Input placeholder="请输入模块英文显示标题" />
                </Form.Item>

                {/* <Form.Item
                    name="path"
                    label="访问路径"
                    rules={[
                        { required: true, message: '访问路径不能为空' },
                        { pattern: /^[a-z\d_]{2,20}$/, message: '访问路径不符合格式要求' },
                    ]}
                    help={
                        <>
                            填写访问该模块的访问路径，如会议简介访问路径 <b>introduction</b><br />
                            格式合求：小写字母、数字或下划线（_），限2-20个字符
                        </>
                    }
                >
                    <Input placeholder="请输入模块访问路径" minLength={2} maxLength={20} showCount disabled={currentModule?.moduleType <= 10} />
                </Form.Item> */}
                <Form.Item label="会刊文件" name="doc" extra="支持PDF格式，大小不超过30MB">
                    <>
                        {docList ? (
                            <div className="docBox">
                                <div className="docIcon" title="PDF 文件">
                                    <i className="bi bi-file-pdf"></i>
                                </div>
                                <div className="docName">{docList.name}</div>
                            </div>
                        ) : null}

                        <Upload customRequest={uploadFile} name="file" maxCount={1} fileList={[]}>
                            <Button
                                className="btnWithIcon"
                                icon={
                                    <>
                                        <i className="bi bi-cloud-arrow-up"></i>
                                    </>
                                }
                            >
                                {docList ? '更换文件' : '上传文件'}
                            </Button>
                        </Upload>
                    </>
                </Form.Item>
                <Form.Item
                    name="status"
                    label="导航状态"
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <Radio.Group>
                        <Radio value={1}>开启</Radio>
                        <Radio value={2}>敬请期待</Radio>
                    </Radio.Group>
                </Form.Item>
                <Form.Item name="hiddenWeb" label="Web端是否隐藏" rules={[{ required: true }]}>
                    <Radio.Group>
                        <Radio value={0}>显示</Radio>
                        <Radio value={1}>隐藏</Radio>
                    </Radio.Group>
                </Form.Item>

                <Form.Item name="hiddenH5" label="H5端是否隐藏" rules={[{ required: true }]}>
                    <Radio.Group>
                        <Radio value={0}>显示</Radio>
                        <Radio value={1}>隐藏</Radio>
                    </Radio.Group>
                </Form.Item>
            </Form>
        </Drawer>
    );
};
